import React, { useContext, useCallback, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import "../../styles/kui-base.css";
import {
  AppBar,
  AppBarLogo,
  Avatar,
  Dropdown,
  Text,
} from "@kui/foundations-react";
import { Clipboard, Exit, ScaleBalance } from "@nv-brand-assets/react-icons-inline";
import SimpleFooter from "../../components/simplefooter";
import Header from "../../components/header";
import HeroBanner from "../../static/images/hero-banner.png";
import "./styles.css";
import "../../styles/Loader.css";
import ApplicationHub from "../../components/applicationhub/ApplicationHub";

import {
  fetchApplicationsByUser,
  fetchUserDetailsByEmail,
  // isTokenExpiredasync,
} from "../../api";

import WithAuth from "../../components/auth/WithAuth";
import { writeUser ,writeHint} from "../../common/loginutils";


// import Button from "@kaizen-ui/button";
import {
  renewAccessTokenCurrentUser,
  isTokenExpiredasync,
} from "../../common/renewaccesstoken";
const Dashboard = () => {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [userName, setUserName] = useState([]);
  const userEmail = localStorage.getItem("email") || "";

  const [userDependenciesLoaded, setUserDependenciesLoaded] = useState(false);
  const [userData, setUserData] = useState(false);

  useEffect(() => {
    (async () => {
      let email = localStorage.getItem("email");
      if (
        email === "" ||
        email === null ||
        email === undefined ||
        email === "undefined"
      ) {
        localStorage.clear();
        localStorage.clear();

        navigate("/login");
      }

      var isTokenExpired = await isTokenExpiredasync();
      if (
        isTokenExpired &&
        localStorage.getItem("TokenExpiredPage") !== null &&
        localStorage.getItem("TokenExpiredPage") !== undefined
      ) {
        localStorage.setItem("TokenExpiredPage", window.location.pathname);
        await renewAccessTokenCurrentUser();
      }

      let heading = "";
      const token = localStorage.getItem("ROCP_idToken");

      if (
        email !== "" &&
        email !== null &&
        email !== undefined &&
        token !== "" &&
        token !== null &&
        token !== undefined
      ) {
        let data;

        let appsresponse;
        if (
          localStorage.getItem("UserDetails") !== undefined &&
          localStorage.getItem("UserDetails") !== "" &&
          localStorage.getItem("UserDetails") !== "undefined" &&
          localStorage.getItem("UserDetails") !== null
        ) {
          data = JSON.parse(localStorage.getItem("UserDetails"));
        } else {
          localStorage.removeItem("UserDetails");
          localStorage.removeItem("ApplicationDetails");
        }

        if (
          localStorage.getItem("ApplicationDetails") !== undefined &&
          localStorage.getItem("ApplicationDetails") !== "undefined" &&
          localStorage.getItem("ApplicationDetails") !== "" &&
          localStorage.getItem("ApplicationDetails") !== null
        ) {
          appsresponse = JSON.parse(localStorage.getItem("ApplicationDetails"));
        } else {
          localStorage.removeItem("UserDetails");
          localStorage.removeItem("ApplicationDetails");
        }

        if (
          data !== "" &&
          data !== null &&
          data !== undefined &&
          appsresponse !== null &&
          appsresponse !== undefined
        ) {
          setUserDependenciesLoaded(true);
          setUserData(true);
          heading = "Welcome " + data?.firstname + " " + data?.lastname;
          setUserName(heading);

          let apps = appsresponse;
          setItems(apps);

            if (apps !== null && apps.length && apps.length === 1) {
            let application = apps[0]; 
            if (application.applicationname.toUpperCase() === "NVIDIA LICENSING PORTAL" || application.applicationname.toUpperCase() === "NVIDIA ENTERPRISE SUPPORT") 
            {
                handleCookieEncryption();
            }         
            let searchParams = new URLSearchParams(window.location.search);
            if (searchParams.get("noautoredirect")) {
              let code = decodeURIComponent(searchParams.get("noautoredirect"));
              if (code !== "true" && code !== true) {
                window.location.href = application.applicationurl;
              }
            } else {
              //If user has only NGC Portal Access Write details in iframe             
              if (application.applicationname.toUpperCase() === "NVIDIA NGC") {
                if (
                  localStorage.getItem("idp_id") !== "" &&
                  localStorage.getItem("idp_id") !== null &&
                  localStorage.getItem("idp_id") !== undefined &&
                  localStorage.getItem("sub") !== "" &&
                  localStorage.getItem("sub") !== null &&
                  localStorage.getItem("sub") !== undefined
                ) {
                  writeUser(
                    localStorage.getItem("email"),
                    localStorage.getItem("idp_id"),
                    localStorage.getItem("expire_at"),
                    localStorage.getItem("sub")
                  );
                }
              }  
              // NPN login_hint Use
               if (application.applicationname.toUpperCase() === "NPN PORTAL") {
                if (
                  localStorage.getItem("idp_id") !== "" &&
                  localStorage.getItem("idp_id") !== null &&
                  localStorage.getItem("idp_id") !== undefined &&
                  localStorage.getItem("sub") !== "" &&
                  localStorage.getItem("sub") !== null &&
                  localStorage.getItem("sub") !== undefined
                ) {                   
                   await writeHint(
                    localStorage.getItem("email"),
                    localStorage.getItem("idp_id"),
                    localStorage.getItem("expire_at"),
                    localStorage.getItem("sub")
                  );
                }
              }   

              window.location.href = application.applicationurl;
            }
          }
        } else {
          data = await fetchUserDetailsByEmail();
          if (data.statusCode === 404) {
            setUserData(false);
            navigate("/usererror");
          }
          if (data.statusCode === 401 || data.statusCode === 500) {
            localStorage.clear();
            localStorage.clear();
            navigate("/login");
          }
          if (data.statusCode === 200) {
            var res = data.data;
            localStorage.setItem("UserDetails", JSON.stringify(res.data));
            setUserDependenciesLoaded(true);

            if (res.earrestricted === true) {
              setUserData(false);
              navigate("/earrestricted");
            }
             else if (res.isactive === false) {
              setUserData(false);
              navigate("/usererror");
            } else {
              setUserData(true);
              heading = "Welcome " + res?.firstname + " " + res?.lastname;
              setUserName(heading);

              let resdata = await fetchApplicationsByUser();
              if (resdata.statusCode === 401 || data.statusCode === 500) {
                localStorage.clear();
                localStorage.clear();
                navigate("/login");
              }
              if (resdata.statusCode === 200) {
                let apps = resdata.data;
                setItems(apps);
                localStorage.setItem(
                  "ApplicationDetails",
                  JSON.stringify(resdata.data)
                );
                if (apps !== null && apps.length && apps.length === 1) {
                  let application = apps[0];
                  let searchParams = new URLSearchParams(
                    window.location.search
                  );
                  if (searchParams.get("noautoredirect")) {
                    let code = decodeURIComponent(
                      searchParams.get("noautoredirect")
                    );
                    if (code !== "true" && code !== true) {
                      window.location.href = application.applicationurl;
                    }
                  } else {
                    window.location.href = application.applicationurl;
                  }
                }
              }
            }
          }
        }
      } else {
        localStorage.clear();
        localStorage.clear();
        navigate("/login");
      }
    })();
  }, [navigate]);

  const handleCookieEncryption = async () => {
    const encryptionKey = process.env.REACT_APP_APPHUB_ENCRYPTION_KEY; // Secret Key
    const deeplinkingUrl = process.env.REACT_APP_deeplinking_url; // Deeplinking Url

    // Ensure the key length is 128 bits (16 bytes) or 256 bits (32 bytes) for AES
    const encoder = new TextEncoder();
    let keyData = encoder.encode(encryptionKey); // Convert the key to an array of bytes

    // Import the key into the Web Crypto API (AES-CBC)
    const key = await crypto.subtle.importKey(
        'raw',
        keyData,
        { name: 'AES-CBC' },
        false,
        ['encrypt', 'decrypt']
    );

    // Generate a random IV (16 bytes for AES)
    const iv = crypto.getRandomValues(new Uint8Array(16));

    // Get the email value to encrypt
    const email = localStorage.getItem("email");

    // --- Instead of encrypting just `email`:
    const payload = JSON.stringify({
      email: email     
    });

    const encryptedData = await crypto.subtle.encrypt(
      { name: 'AES-CBC', iv },
      key,
      encoder.encode(payload)
    );

    // Convert the encrypted data and IV to Base64 for easy transmission
    const encryptedArray = new Uint8Array(encryptedData);
    const ivBase64 = btoa(String.fromCharCode(...iv)); // Convert IV to Base64
    const encryptedBase64 = btoa(String.fromCharCode(...encryptedArray)); // Convert encrypted data to Base64

    // Concatenate the IV and encrypted data with a dot separator
    const encryptedCookieValue = `${ivBase64}.${encryptedBase64}`;

    // Set the encrypted cookie with the combined IV and encrypted value
    document.cookie = `apphubUserData=${encryptedCookieValue}; domain=${deeplinkingUrl}; path=/; Secure;SameSite=None`;
}; 

  const handleClick = (url, appname) => async (e) => {     
    e.preventDefault();  
    if (appname.toUpperCase() === "NVIDIA NGC") {
      if (
        localStorage.getItem("idp_id") !== "" &&
        localStorage.getItem("idp_id") !== null &&
        localStorage.getItem("idp_id") !== undefined &&
        localStorage.getItem("sub") !== "" &&
        localStorage.getItem("sub") !== null &&
        localStorage.getItem("sub") !== undefined
      ) {
        writeUser(
          localStorage.getItem("email"),
          localStorage.getItem("idp_id"),
          localStorage.getItem("expire_at"),
          localStorage.getItem("sub")
        );
      }
    }  
    // NPN login_hint Use  
    if (appname.toUpperCase() === "NPN PORTAL") {
      if (
        localStorage.getItem("idp_id") !== "" &&
        localStorage.getItem("idp_id") !== null &&
        localStorage.getItem("idp_id") !== undefined &&
        localStorage.getItem("sub") !== "" &&
        localStorage.getItem("sub") !== null &&
        localStorage.getItem("sub") !== undefined
      ) {       
        await writeHint(
                    localStorage.getItem("email"),
                    localStorage.getItem("idp_id"),
                    localStorage.getItem("expire_at"),
                    localStorage.getItem("sub")
                  );
      }
   }
    window.open(url, "_blank");

    if (appname.toUpperCase() === "NVIDIA LICENSING PORTAL" || appname.toUpperCase() === "NVIDIA ENTERPRISE SUPPORT") 
    {
      handleCookieEncryption();
    }

  };

  // const handlerenClick = () => {
  //   renewAccessTokenCurrentUser();
  // };
  return (
    <div>
      {!userDependenciesLoaded ? (
        <div className="loader-container">
          {" "}
          <div className="loader"></div>
        </div>
      ) : userData ? (
        <div className="kui-scope">
          <AppBar
            slotStart={<AppBarLogo />}
            slotEnd={
              <Dropdown
                size="small"
                align="end"
                items={[
                  {
                    children: "Sign Out",
                    slotStart: <Exit variant="fill" />,
                    danger: true,
                    onSelect: () => navigate("/logout"),
                  },
                ]}
              >
                <Avatar
                  fallback={userEmail.charAt(0).toUpperCase()}
                  alt=""
                  size="small"
                />
                {userEmail}
              </Dropdown>
            }
          />

          <section
            className="hub-hero"
            style={{ backgroundImage: `url(${HeroBanner})` }}
          >
            <div className="hub-hero-overlay" />
            <div className="hub-hero-content">
              <Text className="hub-welcome-text">{userName}</Text>
              <Text asChild kind="display/lg">
                <h1>NVIDIA Application Hub</h1>
              </Text>
              <Text asChild kind="body/regular/md" fontSize="24" lineHeight="175">
                <p>Access the tools and services you need quickly and easily</p>
              </Text>
            </div>
          </section>

          {/* <div class="application-hub">
            <div
              style={{
                backgroundImage: `url(${Background})`,
                backgroundSize: "100% auto",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="dashboard-heading">
                <div
                  style={{ marginTop: "30px" }}
                  className="dashboard-laptop-heading-huge"
                >
                  NVIDIA Application Hub
                </div>
              </div>
              <div className="dashboard-text">
                <div className="dashboard-laptop-text-large">
                  Access the tools and services you need quickly and easily.
                </div>
              </div>
            </div>
          </div> */}

          <main className="hub-body">
            <ApplicationHub
              items={items}
              ClickEvent={handleClick}
            ></ApplicationHub>
            <SimpleFooter />
          </main>
          {/* <Button
            key="btncreateresponse"
            icon={{ name: "ActionsCircleAdd", variant: "solid" }}
            onClick={() => {
              handlerenClick();
            }}
          ></Button> */}
        </div>
      ) : (
        <div>
          <Header
            headerHeading="NVIDIA Application Hub"
            loginHeader={true}
            dashboardHeader={false}
          ></Header>
          <div className="centered-message-app">
            <div className="centered-message">
              <p>
                {" "}
                Not a valid user. Please visit{" "}
                <Link
                  className="sign-in-text sign-in-text-medium"
                  to="/needhelp"
                >
                  Need help?
                </Link>{" "}
                for more information.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default WithAuth(Dashboard);
